import { render, staticRenderFns } from "./StandardPackageListItem.vue?vue&type=template&id=0ff9c266&scoped=true"
import script from "./StandardPackageListItem.vue?vue&type=script&lang=js"
export * from "./StandardPackageListItem.vue?vue&type=script&lang=js"
import style0 from "./StandardPackageListItem.vue?vue&type=style&index=0&id=0ff9c266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9c266",
  null
  
)

export default component.exports